<section class="grafico">
  <article [class.escuro]="isEscuro">
    <div class="barras">
      <virtual-scroller #scroll [items]="indices" [horizontal]="true" [enableUnequalChildrenSizes]="true"
                        (vsChange)="getChange($event)">
        <ng-container *ngFor="let iqar of scroll.viewPortItems; let i = index">
          <div class="barra" *ngIf="!iqar.divisoria">
            <div class="poluente" [class.atual]="scroll.viewPortItems.length - 1 == i">
              <div class="balao">
                <p>{{iqar.medicao.indiceQualidadeAr | iqar:iqar.medicao.codigo}}</p>
                <p>{{iqar.poluente.noPoluente}}</p>
              </div>
              <div class="triangulo"></div>
            </div>
            <div class="progresso classificacao-{{iqar.classificacaoIqAr.id}}"
                 [style.height.px]="iqar.medicao.valor"></div>
            <p class="hora">{{iqar.medicao.dtMedicao | date:'HH:mm'}}</p>
            <p class="data-barra">
              {{i != 0 ? '&nbsp;' : iqar.medicao.dtMedicao | date:'dd/MM/yyyy'}}
            </p>
          </div>
          <div class="barra" *ngIf="iqar.divisoria">
            <div class="divisoria"></div>
            <p class="data-divisoria">
              {{iqar.dtMedicao | date:'dd/MM/yyyy'}}
            </p>
          </div>
        </ng-container>
      </virtual-scroller>
    </div>
  </article>
</section>
<div class="setas" *ngIf="!resumo">
  <div>
    <ion-icon *ngIf="!start" name="arrow-back-outline"></ion-icon>
  </div>
  <div>
    <ion-icon  *ngIf="!end" name="arrow-forward-outline"></ion-icon>
  </div>
</div>

